import { colors } from '../colors';

export const getProfitColor = (value: number | null | undefined) => {
  if (!value) {
    return colors.white;
  }

  if (value > 0) {
    return colors.green;
  }

  return colors.red;
};

export const transformHexToRgbColor = (hex: string) => {
  const parts = hex.slice(1).split('');

  // Convert each part to a number.
  const r = parseInt(`${parts[0]}${parts[1]}`, 16);
  const g = parseInt(`${parts[2]}${parts[3]}`, 16);
  const b = parseInt(`${parts[4]}${parts[5]}`, 16);

  return [r, g, b];
};

const getRgbValues = (color: string) => {
  if (!color.includes('rgb')) {
    return transformHexToRgbColor(color);
  }

  const regex = /rgb\((\d{1,3}, \d{1,3}, \d{1,3})\)/;
  const match = regex.exec(color);

  if (!match) {
    return [255, 255, 255];
  }

  return [
    parseInt(match[1], 10),
    parseInt(match[2], 10),
    parseInt(match[3], 10),
  ];
};

const transformRgbValuesToColorString = (rgb: number[]) =>
  `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;

export const calculateLuminance = (color: string) => {
  const rgb = getRgbValues(color);

  // Calculate the luminance of the color.
  return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
};

export const calculateIsColorTooDark = (color: string) => {
  // Return true if the luminance is less than 80.
  return calculateLuminance(color) < 80;
};

export const lightenColor = (color: string, weight?: number) => {
  const rgb = getRgbValues(color);

  for (let i = 0; i < 3; i++) {
    rgb[i] = parseInt(
      Math.min(255, rgb[i] * (3 + (weight ? weight / 50 : 1))).toFixed(),
      10,
    );
  }

  return transformRgbValuesToColorString(rgb);
};

export const darkenColor = (color: string, weight?: number) => {
  const rgb = getRgbValues(color);

  for (let i = 0; i < 3; i++) {
    rgb[i] = parseInt(
      Math.min(255, rgb[i] / (2.2 - (weight ? weight / 100 : 1))).toFixed(),
      10,
    );
  }

  return transformRgbValuesToColorString(rgb);
};
